<div class="d-flex flex-wrap gap-2">
  @for (item of data(); track item.id) {
    <button
      type="button"
      class="chip-btn"
      [class.active]="isSelected(item.id)"
      (click)="toggle(item.id)"
    >
      @if (isSelected(item.id)) {
        <i class="bi bi-check me-1 text-primary"></i>
      }
      {{ item.name }}
    </button>
  }
</div>
